var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocationPin = function SvgLocationPin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 11C10.5 10.1716 11.1716 9.5 12 9.5H12.01C12.8384 9.5 13.51 10.1716 13.51 11V11.01C13.51 11.8384 12.8384 12.51 12.01 12.51H12C11.1716 12.51 10.5 11.8384 10.5 11.01V11Z",
    fill: "#22C59E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7927 6.20696C14.1457 3.55992 9.854 3.55992 7.20696 6.20696C4.55992 8.854 4.55992 13.1457 7.20696 15.7927L11.9999 20.5856L16.7927 15.7927C19.4398 13.1457 19.4398 8.854 16.7927 6.20696ZM5.79275 4.79275C9.22083 1.36466 14.7789 1.36466 18.207 4.79275C21.635 8.22083 21.6351 13.7789 18.207 17.207L12.707 22.707C12.5194 22.8945 12.2651 22.9999 11.9999 22.9999C11.7346 22.9999 11.4803 22.8945 11.2927 22.707L5.79275 17.207C2.36466 13.7789 2.36466 8.22084 5.79275 4.79275Z",
    fill: "#22C59E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocationPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "location-pin.0c3272cd469802de26336ab92a7a2b3f.svg";